/*
	日期：2025/08/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：项目主配置界面
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
*/

// 引入 Vue 
import Vue from 'vue'

// 共享样式
import './shared/default_style.css' // 引入共享CSS文件

// 主界面入口
import App from './App.vue'

// 全局引入 ElementUI
import ElementUI from 'element-ui'
// 部分引入 ElementUI
//import { Row, Button, Container, Header, Aside, Main, Footer } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// Vue 路由配置
// 默认 index.js
//import router from './router/index.js'
import router from './router'

// Vuex 路由配置
import store from './store'

// Mock 虚拟数据
import './api/mock'

import Cookies from 'js-cookie'

// 引入全局工具函数
import { globalUtils, constants, defaultConfig } from './utils/globalUtils'

// 用于控制是否在控制台显示生产环境相关的提示信息。
Vue.config.productionTip = false

// 加载 ElementUI 组件
Vue.use(ElementUI)
/*
Vue.use(Row)
Vue.use(Button)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
*/

const DEFAULT_TITLE = '运营中心';

// ========== 全局变量配置开始 ==========
// 全局配置变量
Vue.prototype.$appConfig = {
	...defaultConfig,
	company: '终结司令官',
	version: '1.0.0',
	poweredBy: 'finalcommander.com',
	supportedBy: 'IOE.TOP',
	apiBaseUrl: process.env.VUE_APP_API_BASE_URL || '/api'
}

// 全局常量
Vue.prototype.$constants = constants

// 全局工具函数
Vue.prototype.$utils = globalUtils

// 全局通知封装（基于 ElementUI）
Vue.prototype.$notice = {
	success(message) {
		Vue.prototype.$message.success(message)
	},
	error(message) {
		Vue.prototype.$message.error(message)
	},
	warning(message) {
		Vue.prototype.$message.warning(message)
	},
	info(message) {
		Vue.prototype.$message.info(message)
	}
}
// ========== 全局变量配置结束 ==========

// 全局处理导航错误
const originalPush = router.push
router.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err && err.name !== 'NavigationDuplicated') {
      //console.error('导航错误:', err)
    }
  })
}

// 添加全局前置导航守卫
router.beforeEach((to, from, next) => {
	//console.log(from);
	//console.log(to);
	// 设置标题
	document.title = to.meta.title || DEFAULT_TITLE
	// ...
	// 判断 token 是否存在
	const curUserLogin = Cookies.get('curUserLogin');
	// curUserLogin 不存在，当前用户未登录， 跳转至登陆页面
	if(to.name === 'regVender' || to.name === 'regStaff' || to.name === 'regPartner') {
		next();
		//next({ name: to.name });
	}
	else if(!curUserLogin && to.name !== 'loginUser') {
		next({ name: 'loginUser' });
	}
	else if(curUserLogin && to.name === 'loginUser')
	{
		next({ name: 'main' });
	}
	else
	{
		next();
	}
})

// 路由挂载，挂载到根节点
new Vue({
	router,
	store,
	render: h => h(App),
	created() {
		store.commit('tab/setRouterRules', { router: router, menu: null});
	}
}).$mount('#app')
